<template>
    <div :class="layoutClass">
        <main class="auth-layout__content">
            <common-content-spacer height="medium">
                <slot></slot>
            </common-content-spacer>

            <terms-of-use v-if="showTerms"></terms-of-use>
        </main>
        <portal-target name="modals"></portal-target>
    </div>
</template>

<script>
    import TermsOfUse from 'components/page-elements/terms-of-use/TermsOfUseFooter'
    import VersionUpdateServiceWorkerMixin from 'mixins/VersionUpdateServiceWorkerMixin'

    export default {
        mixins: [VersionUpdateServiceWorkerMixin],

        components: {
            TermsOfUse,
        },

        props: {
            isPlain: { type: Boolean, default: false },
            showTerms: { type: Boolean, default: true },
        },

        computed: {
            layoutClass() {
                return {
                    'auth-layout': true,
                    'auth-layout__plain': true,
                    'auth-layout--plain': this.isPlain,
                    [`auth-layout--image-${this.image}`]: !this.isPlain,
                }
            },
        },
    }
</script>
